import { fetchApiData } from "client/utils/fetchApiData";
import { ShipmentCreationResponse } from "../types/actions";

export const getShipmentById = (shipmentId: string): Promise<ShipmentCreationResponse> => {
  return fetchApiData({ url: `/api/user/shipments/${shipmentId}/` });
};
